const queryBag = new URLSearchParams(window.location.search);

const queryList = {};

queryBag.forEach((v, k) => {
  queryList[k] = v;
});

export { queryBag, queryList };
